import React from 'react'
import { MONTH_STR } from '../../utils/config'
import styles from './Date.module.css'
interface IProps {
  date: string
}

export const RenderDate: React.FC<IProps> = (props) => {
  const d = new Date(props.date)
  return (
    <div className={styles.reportDate}>
      <span className={styles.reportDay}>{d.getDate()}</span>
      <span className={styles.reportMonth}>{MONTH_STR[d.getMonth()]}</span>
      <span>{d.getFullYear()}</span>
    </div>
  )
}
